
import LatestProducts from "./Latest/LatestProducts";
import LatestSaleProduct from "./Latest/LatestSaleProduct";
import TopRating from "./TopRating/TopRating";
import WelcomeMessage from "./WelcomeMessage/WelcomeMessage";

export default function HomePage(){
    return(
        <div>
           
            <WelcomeMessage/>
            <LatestSaleProduct/>
            <TopRating/>
            <LatestProducts/>
        </div>
    )
}